import React from 'react';
import PropTypes from 'prop-types';
import { getFileExtension } from 'utilities/common';
import './styles.scss';

const filePdf = require('assets/images/file/pdf.svg');
const fileDoc = require('assets/images/file/doc.svg');
const fileXls = require('assets/images/file/xls.svg');
const filePng = require('assets/images/file/png.svg');
const fileJpg = require('assets/images/file/jpg.svg');
const fileDefault = require('assets/images/file/file.svg');

const fileLogo = {
  pdf: filePdf,
  doc: fileDoc,
  docx: fileDoc,
  xls: fileXls,
  xlsx: fileXls,
  png: filePng,
  jpg: fileJpg,
  jpeg: fileJpg,
  gif: fileJpg,
};

const FilePreview = ({ fileName, showName, file, extra }) => {
  const { name, extension } = file || getFileExtension(fileName);
  return (
    <div id="my-file-preview">
      <img src={fileLogo[extension] || fileDefault} alt="logo" />
      {showName && (
        <div className="file-preview-info">
          <span className="file-name">{name}</span>
          {extra || null}
        </div>
      )}
    </div>
  );
};

FilePreview.propTypes = {
  fileName: PropTypes.string,
  showName: PropTypes.bool,
};
FilePreview.defaultProps = {
  showName: false,
};

export default FilePreview;
